import {Link} from 'react-router';
import {useAuth} from '../hooks/AuthContext';
import './DentistDashboard.css';

/** Quick links for dentists (accounts linked to a doctor record). */
const DentistDashboard = () => {
  const auth = useAuth();
  if (!auth || !auth.user || !auth.user.doctor) return null;

  return (
    <div className="dentist-dashboard-widget">
      <h4>Dentist Tools</h4>
      <div className="dentist-dashboard-card">
        <div className="dashboard-item">
          <Link to="/virtual-consultation/doctor" className="dashboard-link">
            <span className="dashboard-icon" aria-hidden="true">
              🩺
            </span>
            <div className="dashboard-content">
              <h5>Consultation Requests</h5>
              <p>Approve requests and join video visits</p>
            </div>
          </Link>
        </div>
        <div className="dashboard-item">
          <Link to="/dentist/availability?type=open" className="dashboard-link">
            <span className="dashboard-icon" aria-hidden="true">
              ✅
            </span>
            <div className="dashboard-content">
              <h5>Open Time Windows</h5>
              <p>View and manage your available hours</p>
            </div>
          </Link>
        </div>
        <div className="dashboard-item">
          <Link to="/dentist/availability?type=reject" className="dashboard-link">
            <span className="dashboard-icon" aria-hidden="true">
              🚫
            </span>
            <div className="dashboard-content">
              <h5>Rejected Time Windows</h5>
              <p>View and manage your blocked times</p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DentistDashboard;
